import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import Tag from './Tag';

const Rows = (props: any) => {
  const dataRow = props.data.item;

  const handleDialogComparative = (data: any) => {
    props.handleDialogComparative(data);
  };

  const handleTagClick = (value: string = '') => {
    console.log(value);
  };

  return dataRow.map((data: any, index: number) => {
    return (
      <TableRow
        key={index}
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
        }}
      >
        <TableCell>{data.id}</TableCell>
        <TableCell>
          <Stack>
            <Typography fontSize={'10px'} fontWeight={500}>
              {data?.kana || ''}
            </Typography>
            <Typography fontSize={'12px'} fontWeight={500}>
              {data?.fullname || ''}
            </Typography>
          </Stack>
        </TableCell>
        {index === 0 && (
          <>
            <TableCell align='left' rowSpan={dataRow.length}>
              <Stack
                direction={'row'}
                justifyContent={'flex-start'}
                spacing={'8px'}
              >
                <Tag
                  text='患者名'
                  color='#F6BB42'
                  borderColor='#F6BB42'
                  clickable={true}
                  handleClick={() => handleTagClick('患者名')}
                />
                <Tag
                  text='電話番号'
                  color='#FC6E51'
                  borderColor='#FC6E51'
                  clickable={true}
                  handleClick={() => handleTagClick('患者名（カナ）')}
                />
                <Tag
                  text='住所'
                  color='#AC92EC'
                  borderColor='#AC92EC'
                  clickable={true}
                  handleClick={() => handleTagClick('住所')}
                />
                <Tag
                  text='生年月日'
                  color='#37BC9B'
                  borderColor='#37BC9B'
                  clickable={true}
                  handleClick={() => handleTagClick('生年月日')}
                />
                <Tag
                  text='メールアドレス'
                  color='#4FC1E9'
                  borderColor='#4FC1E9'
                  clickable={true}
                  handleClick={() => handleTagClick('メールアドレス')}
                />
              </Stack>
            </TableCell>
            <TableCell width={'80px'} rowSpan={dataRow.length}>
              <BtnOutlineGradient
                text='確認'
                handleButtonClick={() => handleDialogComparative(data)}
                width='70px'
              />
            </TableCell>
          </>
        )}
      </TableRow>
    );
  });
};

export default Rows;
